import {isDate, isWithinInterval} from 'date-fns';

export class Week {
  public end: Date;
  public name: string;
  public start: Date;

  public constructor() {
    this.end   = null;
    this.name  = null;
    this.start = null;
  }

  public get active(): boolean {
    if(!isDate(this.start) || !isDate(this.end)) {
      return false;
    }

    const today = new Date();
    return isWithinInterval(today, {start: this.start, end: this.end});
  }

  public get label(): string {
    if(!this.name) {
      return '';
    }

    return `Week ${this.name}`;
  }
}
